import React from 'react';
import { useDispatch } from 'react-redux';
import { goBackBreadcrumbAction } from '../../../store/workspaces/breadcrumb/actions';
import { useTranslation } from 'react-i18next';
import { run as runActions } from '../../../store/workspaces/workspaces/run';
import PropTypes from 'prop-types';
import { TabService } from 'src/api/services/workspaces/Service.tab';
import store from 'src/store/store';

const PageItem = ({ itemIndex, params, isLast }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleClick = async () => {
    await runActions(params.key, params.id, params ?? {});
    dispatch(goBackBreadcrumbAction(itemIndex));

    const tabService = new TabService();
    await tabService.setTab(store.getState().workspaces.instances.find(instance => instance.isActive), null);
  };

  const setName = (name) => {
    const full = t(name) || '';
    return full.length > 30 ? full.slice(0, 30) + ' ...' : full || t('no title');
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 ${isLast ? 'text-gray-600' : 'text-gray-400 hover:text-gray-600'}`}
    >
      {params.config?.icon?.name && (
        <div
          className={`e-icons e-${params.config.icon.name}`}
          style={{ color: params.config.icon.color }}
        />
      )}
      <span>{setName(params.config?.label?.name)}</span>
    </button>
  );
};

PageItem.propTypes = {
  itemIndex: PropTypes.number,
  params: PropTypes.object,
  isLast: PropTypes.bool,
};

export default PageItem;
